import SFetch from '@app/utils/sfetch'
import { SfLog } from '@app/adapters/logger'
import type { DocumentPreviewResponse } from './types'

// Fetches a document's `#preview` payload from the firm/company-scoped endpoint.
// Errors are logged and swallowed (returns undefined) so callers can degrade to
// an empty preview rather than throw.
export async function getDocumentPreview(
  documentId: number
): Promise<DocumentPreviewResponse | null | undefined> {
  const previewPath = window.Silverfin.Routes.preview_document_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    { id: documentId }
  )

  try {
    return await SFetch.json<DocumentPreviewResponse>(previewPath)
  } catch (error) {
    SfLog.error('Error fetching document preview:', { error })
    return
  }
}
